/* eslint-disable */
import React from 'react'
import styled from 'styled-components'

import { useTranslation } from "react-i18next"

const AboutSidebarStyle = styled.menu`
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    border: solid 1px #dcdcdc;
    > li {
      margin: 0;
      padding: 0;
      cursor: pointer;
      display: flex;
      width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 10px 24px;
        width: 100%;
        display: flex;
        text-decoration: none;
        background: #fff;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #191919;
        transition: all 0.3s ease-in;
        path:last-child {
          fill: #ff7400;
          transition: all 0.3s ease-in;
        }
        &:hover {
          color: #ff7400;
        }
        &.active {
          background: linear-gradient(to left, #ff9700, #ff7400);
          color: #fff;
          transition: all 0.3s ease-in;
          path:last-child {
            transition: all 0.3s ease-in;
            fill: #fff;
          }
        }
      
    }
  }
`

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="17"
      viewBox="0 0 7 17"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M-9-6h24v24H-9z" />
        <path
          fillRule="nonzero"
          d="M1.238 0l5.17 5.805L7 6.5l-.592.695L1.238 13 0 11.61 4.55 6.5 0 1.39z"
        />
      </g>
    </svg>
  )
}

const scrollToFunction = (target) => {
  let targetOffset = document.getElementById(target).offsetTop - 85;
  window.scrollTo(0, targetOffset);
  document.getElementById(target).click();
}

const SidebarPayment = () => {
  const { t } = useTranslation()
  const DataSidebar = [
    {
      id: 'payment-1',
      title: t('pagePayment.part1'),
      targetScroll: 'payment-1'
    },
    {
      id: 'payment-2',
      title: t('pagePayment.part7'),
      targetScroll: 'payment-2'
    },
    {
      id: 'payment-3',
      title: t('pagePayment.part25'),
      targetScroll: 'payment-3'
    },
    {
      id: 'payment-4',
      title: t('pagePayment.part40'),
      targetScroll: 'payment-4'
    },
    {
      id: 'payment-5',
      title: t('pagePayment.part50'),
      targetScroll: 'payment-5'
    },
    {
      id: 'payment-6',
      title: t('pagePayment.part60'),
      targetScroll: 'payment-6'
    },
    {
      id: 'payment-7',
      title: t('pagePayment.part70'),
      targetScroll: 'payment-7'
    },
    {
      id: 'payment-8',
      title: t('pagePayment.part80'),
      targetScroll: 'payment-8'
    },
    {
      id: 'payment-9',
      title: t('pagePayment.part89'),
      targetScroll: 'payment-9'
    },
    {
      id: 'payment-10',
      title: t('pagePayment.part108'),
      targetScroll: 'payment-10'
    }
  ]
  return (
    <AboutSidebarStyle>
      <ul>
        {DataSidebar.map((value, index) => {
          return (
            <li onClick={() => scrollToFunction(value.targetScroll)} key={`privary-title-${index}`}>
              {value.title}
              {/* <ArrowIcon></ArrowIcon> */}
            </li>
          )
        })}
      </ul>
    </AboutSidebarStyle>
  )
}

export default SidebarPayment
